import React from 'react';
import TimerForm from './TimerForm';
import { addTimer } from '../../api';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.appBar = {
      title: 'NEW_TIMER',
      navigateBack: true,
    };
  }

  render() {
    return (
      <TimerForm
        name="addTimer"
        appBar={this.appBar}
        request={addTimer}
        confirmExit
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Timer/TimerAddition.js
 **/